/* eslint-disable unicorn-x/filename-case */
import { createFileRoute } from '@tanstack/react-router';

import { RedeemToken } from '~ai-tutor/components/redeemToken/RedeemToken';

export const Route = createFileRoute('/_authed/oidc/redeem-token')({
  component: RedeemToken,
});
